import { useAccountSummary } from '../const/syfApiQueries';
import { getSelectedAccountId } from '../helpers/sessionAccountId';
var useSelectedClientId = function (config) {
    var _a;
    var selectedAccountId = getSelectedAccountId();
    var accountSummary = useAccountSummary(selectedAccountId, config).data;
    return (_a = accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.product.clientId) !== null && _a !== void 0 ? _a : '';
};
export default useSelectedClientId;
